// extracted by mini-css-extract-plugin
export default {"contactoMain":"contactoMain_contactoMain__dELUG"};